import React from 'react';
import { useNavigate } from 'react-router-dom';
import './Dashboard.css';

const Dashboard = ({ user }) => {
  const navigate = useNavigate();
  
  // Check if user has admin privileges
  const isAdmin = user?.role === 'admin';
  // Check if user can import bookings (admin or backoffice)
  const canImportBookings = user?.role === 'admin' || user?.role === 'backoffice';

  return (
    <div className="dashboard">
      <main className="dashboard-main">
        <div className="dashboard-grid">
          <div className="dashboard-card">
            <h3>Aufträge</h3>
            <p>Verwalten Sie aktuelle und vergangene Aufträge</p>
            <div className="dashboard-card-buttons">
              <button className="card-button" onClick={() => {
                console.log('Navigating to orders...');
                navigate('/orders');
              }}>Aufträge anzeigen</button>
            </div>
          </div>
          
          <div className="dashboard-card">
            <h3>Buchungen</h3>
            <p>Zeitslots und Buchungen einsehen</p>
            <div className="dashboard-card-buttons">
              <button className="card-button" onClick={() => navigate('/bookings')}>Buchungen anzeigen</button>
              {canImportBookings && (
                <button className="card-button" onClick={() => navigate('/bookings/import')}>Buchungen importieren</button>
              )}
            </div>
          </div>
          
          {isAdmin && (
            <div className="dashboard-card">
              <h3>Anlagen</h3>
              <p>Mosterei-Anlagen konfigurieren</p>
              <div className="dashboard-card-buttons">
                <button className="card-button" onClick={() => navigate('/facilities')}>Anlagen verwalten</button>
              </div>
            </div>
          )}
          
          {isAdmin && (
            <div className="dashboard-card">
              <h3>Benutzer</h3>
              <p>Benutzerverwaltung und Berechtigungen</p>
              <div className="dashboard-card-buttons">
                <button className="card-button" onClick={() => navigate('/users')}>Benutzer verwalten</button>
              </div>
            </div>
          )}

          {canImportBookings && (
            <div className="dashboard-card">
              <h3>Rechnungen</h3>
              <p>Rechnungsarchiv und Export</p>
              <div className="dashboard-card-buttons">
                <button className="card-button" onClick={() => navigate('/invoices')}>Rechnungen anzeigen</button>
              </div>
            </div>
          )}

          {canImportBookings && (
            <div className="dashboard-card">
              <h3>Berichte</h3>
              <p>Statistiken und Auswertungen</p>
              <div className="dashboard-card-buttons">
                <button className="card-button" onClick={() => navigate('/reports')}>Berichte anzeigen</button>
              </div>
            </div>
          )}

          {isAdmin && (
            <div className="dashboard-card">
              <h3>Einstellungen</h3>
              <p>E-Mail und System-Konfiguration</p>
              <div className="dashboard-card-buttons">
                <button className="card-button" onClick={() => navigate('/settings')}>Einstellungen</button>
              </div>
            </div>
          )}
        </div>
      </main>
    </div>
  );
};

export default Dashboard;